import { animate, state, style, transition, trigger } from '@angular/animations';

export const adminMenuAnimation = trigger('animateMenuOpenClose', [
    state(
        'open',
        style({
            width: '235px',
        }),
    ),
    state(
        'closed',
        style({
            width: '60px',
        }),
    ),
    transition('open <=> closed', [animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
]);
